import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Dropzone from 'react-dropzone';
import JobService from '../../services/JobService';

class JobMedia extends Component {
    constructor(props) {
        super(props);

        this.jobService = new JobService();

        this.state = {
            acceptedFiles: [],
        };
    }

    onDrop = (acceptedFiles) => {
        this.setState({ acceptedFiles });
    };

    removeFile = (file, index) => {
        let acceptedFiles = [...this.state.acceptedFiles];
        acceptedFiles.splice(index, 1);
        this.setState({ acceptedFiles });
    };

    onSubmit = (e) => {
        e.preventDefault();
        const formData = new FormData();
        this.state.acceptedFiles.forEach((file) => formData.append('files[]', file));
        this.jobService.saveJobMedia(this.props.job_id, formData).then((res) => console.log(res.data));
    };

    render() {
        return (
            <div className="row">
                <div className="col-12">
                    <Dropzone onDrop={(acceptedFiles) => this.onDrop(acceptedFiles)}>
                        {({ getRootProps, getInputProps }) => (
                            <section>
                                <div
                                    {...getRootProps()}
                                    className="d-flex flex-column align-items-center jobs-dropzone"
                                >
                                    <input {...getInputProps()} />
                                    {this.state.acceptedFiles.length > 0 ? (
                                        <div className="row w-100">
                                            {this.state.acceptedFiles.map((file, index) => (
                                                <div
                                                    key={index}
                                                    className="col-md-2 d-flex flex-column justify-content-between"
                                                >
                                                    <img src={window.URL.createObjectURL(file)} height="200" />
                                                    <div
                                                        className="text-center dropzone-remove-link"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            e.preventDefault();
                                                            this.removeFile(file, index);
                                                        }}
                                                    >
                                                        remove <i className="fas fa-times"> </i>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        <p className="py-5 text-muted mb-0 jobs-dropzone-placeholder">
                                            Drag and drop, or click to select images and videos related to this job
                                        </p>
                                    )}
                                </div>
                                <div></div>
                            </section>
                        )}
                    </Dropzone>
                    <button>Ahoj</button>
                </div>
            </div>
        );
    }
}

if (document.getElementById('jobMediaDropzone')) {
    let element = document.getElementById('jobMediaDropzone');
    ReactDOM.render(<JobMedia />, element);
}

export default JobMedia;
